import { render } from "./addToGroups.vue?vue&type=template&id=44347d68"
import script from "./addToGroups.vue?vue&type=script&lang=js"
export * from "./addToGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__